import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from 'app/shared/components/Notistack/Notistack';
import { ICreateCheckRequest, ICustomCheckRequestFormValues } from '@modules/accounting/CheckerMenu/interfaces';
import { getError } from '@shared/utils/helpers';

const path = '/accounting-service/checkrequest';

export const submitCheckRequest = (checkrequestData: ICreateCheckRequest | ICustomCheckRequestFormValues, workFlowErrorCallback?: (message?: string) => void,isApproved=true) => {
  // eslint-disable-line
  return mutate(path, async() => {
    try {
      const resp = await axios.post(path, checkrequestData);
      if (isApproved) {
        Notistack.successMessage('Check Request - Created Successfully');
      }
      return resp.data;
    } catch (err) {
      const error = getError(err);
      if (error.includes('Incorrect workflow')) {
        workFlowErrorCallback?.(error);
      } else {
        Notistack.generalError(error);
      }
    }
  });
};
